<template>
  <v-content class="app-layout">
    <v-container>
      <Alert />
      <ContextMenu :title="getTitle()" />
      <slot />
    </v-container>
  </v-content>
</template>
<script>
import ContextMenu from '@/components/ContextMenu'
import Alert from '@/components/Alert'

export default {
  name: 'AppLayout',
  components: { ContextMenu, Alert },
  methods: {
    getTitle() {
      return this.$route.meta.title
    }
  }
}
</script>
